// @ts-ignore
import pako from 'pako'
// @ts-ignore
import resDataProcess from './resDataProcess'
import ReplyMessage_pb from './contractProtoData/replyMessage_pb'
import debugLog from '../../utils/debugLog'

export type TGetSocketMessageKey = (message: MessageEvent) => Promise<{ key: string; data: any } | void>

export const generateMessageId = ({ biz, type, contractCode, env, granularity }) => {
  return `${biz || 'undefined'}_${type || 'undefined'}_${contractCode || 'undefined'}_${env || 'undefined'}_${granularity || 'undefined'}`
}

const getSocketMessageIdAndData: TGetSocketMessageKey = (message: MessageEvent) => {
  return new Promise((resolve, reject) => {
    if (typeof message.data === 'string') {
      let data = JSON.parse(message.data)

      if (data.error_code) {
        reject(data)
        return
      }

      if (data.event === 'pong') return

      if (data.type && data.data) {
        const processedData = resDataProcess(data)
        const key = generateMessageId({
          biz: data.biz,
          type: data.type,
          contractCode: data.contractcode,
          env: data.env,
          granularity: data.granularity,
        })
        resolve({ key, data: processedData })
      }
      return
    }

    //获取数据步骤，
    // 1：将文件流转换为二进制文件，
    // 2: 解压二进制文件,后端采用gzip压缩，
    // 3：将解压数据使用protoBuffer反序列化为实体对象
    // 4：将实体对象转换为json
    let result,
      data,
      reader = new FileReader()
    reader.readAsBinaryString(message.data)
    reader.onload = () => {
      result = pako.inflate(reader.result)
      data = ReplyMessage_pb.ReplyPbMsg.deserializeBinary(result)
      data = data.toObject()
      if (data.error_code) {
        reject(data)
        return
      }

      // 目前看他们原有代码是通过biz和type作为唯一标识
      // if (params.biz !== data.biz || params.type !== data.type) return

      if (data.type != 'subscribe') {
        const processedData = resDataProcess(data)
        if (!processedData || !Object.keys(processedData).length) return
        const key = generateMessageId({
          biz: data.biz,
          type: data.type,
          contractCode: data.contractcode,
          env: data.env,
          granularity: data.granularity,
        })
        debugLog('contractSocketData', key, data, processedData)
        resolve({ key, data: processedData })
      }
    }
  })
}

export const sendMessageHandler = (type: 'subscribe' | 'unsubscribe', params: any, socket: WebSocket) => {
  // todo: 根据入参params判断是否需要登录
  socket?.send(
    JSON.stringify({
      event: 'signin',
      params: {
        token: window.localStorage.getItem('token'),
      },
    })
  )
  return JSON.stringify({
    event: type,
    params,
  })
}
export default getSocketMessageIdAndData
